












import Vue from "vue";
import * as routes from "@/router/routes";

// Vue components
import StandardPage from "@/components/PageTemplates/StandardPage.vue";
import ScheduleMainTable from "./ScheduleMainTable.vue";

// Model
import { dataTableItemsPerPage } from "@/utility/Constants";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { FetchInstallationsScheduleConfigurationRequestData } from "@/model/communication/scheduleConfiguration/FetchInstallationsScheduleConfigurationRequestData";
import { FetchInstallationsScheduleConfigurationCommand } from "@/model/communication/scheduleConfiguration/FetchInstallationsScheduleConfigurationCommand";
import { FetchInstallationsScheduleConfigurationResponse } from "@/model/communication/scheduleConfiguration/FetchInstallationsScheduleConfigurationResponse";

export default Vue.extend({
    components: {
        StandardPage,
        ScheduleMainTable,
    },
    data() {
        return {
            routes,
            dataTableItemsPerPage,
            ScheduleMainTable,
            reqData: null,
            installations: [],
            paginatedTotalItems: null,
            totalsByStatus: [],
            loading: false,
        };
    },
    methods: {
        async sendRequest(request) {
            try {
                this.reqData = request;
                this.loading = true;
                var response: FetchInstallationsScheduleConfigurationResponse = await new FetchInstallationsScheduleConfigurationCommand(request).execute();
                this.loading = false;

                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.installations = response.installationsList;
                    this.paginatedTotalItems = response.paginatedTotalItems;
                }
            } catch (e) {
                console.log("Something went wrong sending FetchInstallationsScheduleConfiguration request ", e);
                this.loading = false;
            }
        },
    },
    mounted() {
        this.reqData = new FetchInstallationsScheduleConfigurationRequestData();
        this.reqData.queryLimit = this.dataTableItemsPerPage[0];
    },
});
